module.exports = __webpack_public_path__ + "static/media/hero-image-3.02cd0e2d.png";